import React from "react";
import ResourceListPage from "components/ResourceListPage";

const Authors = () => <ResourceListPage resource="authors" title="Authors" />;

export default Authors;
